// ==============================
// Replace dynamic text in AfterSell post-purchase
// ==============================
document.addEventListener("DOMContentLoaded", function() {
    // Primer botón: Add an EXTRA Skinny Coffee
    var btn1 = document.querySelector("button._Button_1lnu1_1 span._Content_1lnu1_30");
    if(btn1) {
        btn1.textContent = "Add an EXTRA Skinny Coffee - Save +60%";
    }

    // Segundo botón: Upgrade and Save
    var btn2 = document.querySelector("button._Button_1lnu2_1 span._Content_1lnu2_30");
    if(btn2) {
        btn2.textContent = "Upgrade and Save";
    }
});